import React, { useContext, useEffect, useState } from 'react';
import TopBar from '../Layouts/TopBar';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Sidebar from '../Layouts/Sidebar';
import { AuthContext } from '../Context/AuthProvider';
import { useDelete } from '../Context/ApiContext';
import instance from '../Config/AxiosConfig';
import Lottie from 'react-lottie';
import animationData from '../lotties/ai.json';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { LuPenSquare } from 'react-icons/lu';
import { FaDownload } from 'react-icons/fa';

function MyProfil() {

    const { id } = useParams();
    const [connections, setConnections] = useState([]);
    const { user, isAuth } = useContext(AuthContext)
    const [connectionsNumber, setConnectionsNumber] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [myProfil, setMyProfil] = useState([]);
    const [showAiModal, setShowAiModal] = useState(false);
    const handleAiModalOpen = () => {
        setShowAiModal(true);
    };

    const handleAiModalClose = () => {
        setShowAiModal(false);
    };
    const [numberDocuments, setNumberDocuments] = useState([]);

    const { showConfirmDialog, deleteResponse } = useDelete();

    const api = '/articles/removeResearcher';
    useEffect(() => {
        axios.get(`https://go.vecos.us/reunice/API/v1/users/get/${id}`)
            .then(response => {
                setConnections(response.data.connections);
                setConnectionsNumber(response.data.connectionsNumber);
                const sortedDocuments = response.data.documents.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate))

                setDocuments(sortedDocuments);
                setNumberDocuments(response.data.numberDocuments);
                setMyProfil(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });
    }, [deleteResponse]);



    const downloadFile = async (url, name) => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(urlBlob);
        } catch (error) {
            console.error('There was an error downloading the file:', error);
        }
    };





    const [axes, setAxes] = useState([])
    const [errors, setErrors] = useState([])

    const handleGenerateAxes = async (id) => {

        try {
            const response = await instance.get(`/articles/generateAxes/${id}`)
            console.log("generate axes :", response);

            if (response.data.success == false) {
                setErrors(response.data.error)
            }
            else {
                setAxes(response.data.axes)
            }


        }
        catch (error) {
            console.log(error);
        }

    }


    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const handleOpenAi = (id) => {
        handleAiModalOpen()
        handleGenerateAxes(id)


    }



    const [isSubmitting, setIsSubmitting] = useState(false);

    const [checkedItems, setCheckedItems] = useState({});

    //checked interest
    const handleCheckboxChange = (event, axes) => {
        setCheckedItems({
            ...checkedItems,
            [axes.id]: event.target.checked
        });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const selectedInterests = Object.keys(checkedItems).filter(id => checkedItems[id]);

        try {
            setIsSubmitting(true);
            const requests = selectedInterests.map(id =>
                instance.get(`/interests/add/${id}`)
            );
            const responses = await Promise.all(requests);

            console.log('Responses:', responses);
            const allSuccessful = responses.every(response => response.status === 200);

            if (allSuccessful) {

                toast.success('Interest added successfully!', {
                    position: "top-center",

                    hideProgressBar: false,

                });


                const axesfiltred = axes.filter(interest => !selectedInterests.includes(interest.id.toString()));
                setAxes(axesfiltred);


                setShowAiModal(false);
                setTimeout(() => {
                    fetchCommunities();
                }, 500);
            }

        } catch (error) {
            console.error('Error adding interests:', error);

        } finally {
            setIsSubmitting(false);
        }
    };


    const [communities, setCommunities] = useState([]); // Communautés liées aux intérêts
    const [showCommunityModal, setShowCommunityModal] = useState(false); // État du modal des communautés

    const handleCommunityModalOpen = () => {
        setShowCommunityModal(true);
    };

    const handleCommunityModalClose = () => {
        setShowCommunityModal(false);
    };
    // communauties liées aux intérêts

    // const { interests, handleJoin } = useDelete();
    // const fetchCommunities = async () => {

    //     const token = Cookies.get('token');
    //     const data = new FormData();
    //     interests.forEach(interest => data.append('interests[]', interest));

    //     try {
    //         const response = await instance.post('/communities/getAllFromInterests', data, token);
    //         console.log("wwww");

    //         setCommunities(response.data);

    //         setShowCommunityModal(true);
    //     } catch (error) {
    //         console.error('Error fetching communities by interest:', error);
    //     }
    // };


    // communauties liées aux intérêts

    const { interests } = useDelete();
    const fetchCommunities = async () => {

        const token = Cookies.get('token');
        const data = new FormData();
        interests.forEach(interest => data.append('interests[]', 225));

        try {
            const response = await instance.post('/communities/getAllFromInterests', data, token);


            setCommunities(response.data);
            // Afficher le modal des communautés après avoir reçu les données
            setShowCommunityModal(true);
        } catch (error) {
            console.error('Error fetching communities by interest:', error);
        }
    };


    const handleJoin = async (id) => {
        const token = Cookies.get('token');

        try {
            const response = await instance.get(`/communities/join/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.status === 200) {
                toast.success('Successfully joining the community!', {
                    position: "top-right",
                    autoClose: 500,
                    hideProgressBar: false,
                });

                // Filtrer la communauté qui a été rejointe
                setCommunities(prevCommunities => prevCommunities.filter(community => community.id !== id));
            }
        } catch (error) {
            toast.error('Error joining community!', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
            });
            console.error('Error joining:', error);
        }
    };


    return (
        <>
            <TopBar />
            <main>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3">
                            <Sidebar />
                        </div>
                        <div className="col-md-8 col-lg-9 vstack gap-4">
                            <div className="card">
                                <div className="card-header d-sm-flex align-items-center border-0 pb-0">
                                    <h5 className="card-title mb-sm-0">Discover Publication</h5>
                                    <a className="btn btn-primary-soft btn-sm ms-3" href="#">    <i className="fa-solid list" /> {numberDocuments}</a>
                                </div>
                                <div className="row g-2">
                                    <div className="col-sm-6 col-lg-3  offset-md-8 mt-4">

                                        <Link to="/createPublication">  <span className="btn btn-primary-soft ms-auto w-100"  > <i className="fa-solid fa-plus pe-1" /> add publication</span></Link>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="d-sm-flex align-items-center">
                                            <div className="col-md-12">
                                                <div className="tab-content p-0">
                                                    <div className="tab-pane fade active show" id="profile-post">
                                                        {documents.map((item, index) => (
                                                            <ul key={index} className="timeline">
                                                                <li>
                                                                    <div className="timeline-time">
                                                                        <span className="time fs-6">{item.publicationDate}</span>
                                                                    </div>
                                                                    <div className="timeline-icon">

                                                                    </div>
                                                                    <div className="timeline-body position-relative " >
                                                                        {/* <button className="delete-button  position-absolute top-0 end-0  " onClick={() => showConfirmDialog(api, item.id)} >
                                                                            <svg className="delete-svgIcon" viewBox="0 0 448 512">
                                                                                <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                                                                            </svg>
                                                                        </button> */}
                                                                        {/* <a className="btn btn-link btn-sm position-absolute" style={{ left: '0', top: '0', fontSize: '14px', padding: '4px' }} href={`/updatePublication/${item.id}`}>
                                                                            <LuPenSquare size={25} />
                                                                        </a> */}

                                                                        <div className="timeline-header ">
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div className="d-flex align-items-center">
                                                                                    <h5>{item.titleText}</h5 >
                                                                                </div>
                                                                                {/* Card share action menu */}
                                                                                <a href="#" className="text-secondary btn btn-secondary-soft-hover py-1 px-2 show" id="cardShareAction5" data-bs-toggle="dropdown" aria-expanded="true">
                                                                                    <i className="bi bi-three-dots" />
                                                                                </a>
                                                                                {/* Card share action dropdown menu */}
                                                                                <ul className="dropdown-menu dropdown-menu-end " aria-labelledby="cardShareAction5" style={{ position: 'absolute', inset: 'auto 0px 0px auto', margin: 0, transform: 'translate3d(-20.8px, -227.2px, 0px)' }} data-popper-placement="top-end">
                                                                                    <li><a className="dropdown-item" href={`/updatePublication/${item.id}`}> <i className="bi bi-pencil-square fa-fw pe-2" />Update Publication</a></li>

                                                                                    <li onClick={() => showConfirmDialog(api, item.id)} ><a className="dropdown-item" href="#"> <i className="bi bi-x-circle fa-fw pe-2" />Delete Publication</a></li>
                                                                                    <li onClick={() => downloadFile(item.file, item.file)} ><a className="dropdown-item" href="#"> <i className="bi bi-download fa-fw pe-2" />Download file</a></li>

                                                                                </ul>
                                                                            </div>

                                                                            <p className='mt-4'>{item.abstratText}</p>

                                                                        </div>
                                                                        <div className="timeline-content">
                                                                            <p className='mb-4'>
                                                                                {item.file && (
                                                                                    <>
                                                                                        <i className="bi bi-link" />
                                                                                        <a href={item.file} target="_blank" rel="noreferrer">
                                                                                            Src
                                                                                        </a>
                                                                                    </>
                                                                                )}
                                                                                <span style={{ float: 'right' }}><b>Type:</b> {item.documentType}</span>
                                                                            </p>

                                                                            {/* < FaDownload onClick={() => downloadFile(item.file, item.file)} /> */}


                                                                            <span onClick={() => handleOpenAi(item.id)} style={{ float: 'right' }}>
                                                                                <Lottie
                                                                                    options={defaultOptions}
                                                                                    height={30}
                                                                                    width={40}

                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                </li>
                                                            </ul>
                                                        ))}
                                                    </div>
                                                </div>
                                                {showAiModal &&
                                                    <>


                                                        <Modal show={showAiModal} onHide={handleAiModalClose} style={{ marginTop: "50px" }}>
                                                            <Modal.Header closeButton>
                                                                <Modal.Title>keywords generated from article </Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <form className="row g-3 ms-2">

                                                                    {errors.length > 0 ? <h6 >{errors}</h6>
                                                                        :
                                                                        (axes &&
                                                                            axes.map((axe, i) => {
                                                                                return (
                                                                                    <div className="form-check form-check-md my-3" key={i}>
                                                                                        <input className="form-check-input"
                                                                                            type="checkbox"
                                                                                            id={`axe-${axe.id}`}
                                                                                            checked={checkedItems[axe.id] || false}
                                                                                            onChange={(e) => handleCheckboxChange(e, axe)} />
                                                                                        <label className="form-check-label" htmlFor={`axes-${axe.id}`}>{axe.name}</label>
                                                                                    </div>

                                                                                )
                                                                            })

                                                                        )
                                                                    }
                                                                </form>
                                                            </Modal.Body>

                                                            <Modal.Footer>
                                                                <Button onClick={handleSubmit} disabled={isSubmitting} type="submit" className="btn btn-primary mb-0">{isSubmitting ? 'Saving...' : 'Save changes'}
                                                                </Button>

                                                            </Modal.Footer>


                                                        </Modal>

                                                    </>}


                                                {
                                                    showCommunityModal &&
                                                    <>


                                                        <Modal show={showCommunityModal} onHide={handleCommunityModalClose} style={{ marginTop: "50px" }}>
                                                            <Modal.Header closeButton>
                                                                <Modal.Title>join communities</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <form className="row g-3 ms-2">


                                                                    {errors.length > 0 ? <h6 >{errors}</h6>
                                                                        :

                                                                        communities.map((item, index) => {
                                                                            return (
                                                                                <div className="card card-body" key={index}>
                                                                                    <div className="d-md-flex justify-content-between align-items-start">

                                                                                        <div className="mb-2 mb-md-0">

                                                                                            <p className="small mb-0" >{item.name}</p>
                                                                                        </div>

                                                                                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                                                                            <a class="btn btn-success-soft btn-sm" href="#!" onClick={() => handleJoin(item.id)}> Join </a>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>

                                                                            )
                                                                        })


                                                                    }
                                                                </form>
                                                            </Modal.Body>




                                                        </Modal>

                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </>
    );
}

export default MyProfil;
